'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEVELOPMENT = exports.DEVELOPMENT = 'development';
var BETA = exports.BETA = 'beta';
var PPE = exports.PPE = 'ppe';
var PRODUCTION = exports.PRODUCTION = 'production';


//////////////////
// WEBPACK FOOTER
// ./~/@dp/varyag-hoc-component/config/environments.js
// module id = 64
// module chunks = 0